import React from 'react'
import { css } from 'glamor'
import { Tabs } from 'zent'
import './CustomTabs.css'

const TabPanel = Tabs.TabPanel;
const TabComp = Tabs as unknown as React.FC<{ activeId: string, onChange: (activeId: string) => void }>

export type CustomTabsProps = {
    children: any
}

export type TabItemProps = {
    isActive: boolean
    index: number
    onClickTabItem: (activeTab: string) => void
    name: string
    children: any
}

export const TabItem: React.FC<TabItemProps> = ({ isActive, index, onClickTabItem, name, children }) => {
    return (
        <button
            {
            ...css({
                textAlign: undefined,
                border: '1px solid transparent',
                borderRadius: '50px',
                width: '100px',
                background: isActive ? '#303641' : 'white',
                color: !isActive ? '#C1C1C1' : 'white',
                fontWeight: isActive ? 'bold' : undefined,
                position: 'relative',
                padding: '4px 10px'
            })
            }
            onClick={(e) => {
                e.stopPropagation()
                onClickTabItem(name)
            }}
        >
           {children}
        </button>
    )
}

export const CustomTabs = ({ children }: CustomTabsProps) => {
    return (
        <div
            {
            ...css({
                fontSize: '14px',
                display: 'flex',
                gap: 10
            })
            }
        >
          {children}
        </div>
    )
}

export type TabItem = {
    value: string,
    label: string,
    disabled?: boolean,
    content?: React.ReactNode,
    labelContent?: string
}

export type RegularTabsProps = {
    activeTabId: string,
    onChange: (activeId: string) => void,
    tabItems: TabItem[]
}

export const RegularTabs = ({
    activeTabId,
    onChange,
    tabItems
}: RegularTabsProps) => {
    return (
        <TabComp
        activeId={activeTabId}
        onChange={onChange}
    >
        {tabItems.map(({ value, label, disabled, content, labelContent }) => {
            return (
                <TabPanel disabled={disabled} key={value} tab={labelContent ? (
                    <div dangerouslySetInnerHTML={{
                        __html: labelContent
                    }}>

                    </div>
                ) : label} id={value}>
                    {content}
                </TabPanel>
            )
        })}
    </TabComp>
    )
}

